import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NamedItemInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const LcBasic = (props: {rowData: [], field: string, defaults: {}, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    amt: null,
    amtType: _.get(props, "defaults.lcAmtType"),
    payout: _.get(props, "defaults.lcPayout") || {'payoutMode': 'namedItem', 'payoutNamedItemId': null}
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData    = _.cloneDeep(data)
    if (field.startsWith('payout')){
      nextData['payout']['payoutNamedItemId'] = val 
    } else nextData[field] = val
    if (!nextData['amtType']) nextData['amtType'] = props.defaults['lcAmtType']
    if (!nextData['payout'])  nextData['payout']  = props.defaults['lcPayout']
    if (field === 'amtType' && val === '% of Market' && nextData['payout']) nextData['payout'] = null
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'lcdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('rentroll', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput
            field="amt"
            className="automated billion-input"
            data={data}
            attrs={attrs}
            min={0}
            max={1000000000}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}
          />
        </div>
        <div>
          <label>Amount Type</label>
          <DropdownInput
            field="amtType"
            className="automated ti-amttype"
            data={data}
            attrs={attrs}
            default={props.defaults['tiAmtType']}
            options={['Amt', 'Amt/Area', '% of Rent', '% of Rent + Recovery', '% of Rent: Ignore Free', '% of Rent + Recovery: Ignore Free', '% of All Revenues', '% of Market']}
            persist={updateData}
          />
        </div>
        <div>
          <label>Payout</label>
          <NamedItemInput 
            className="automated named-item-state-input" 
            data={data} 
            disabled={data?.['amtType'] === '% of Market'}
            attrs={attrs} 
            field="payout.payoutNamedItemId" 
            filter={true}
            namedItem="payoutNamedItemId"
            options={props.namedItems['payout'] || []} 
            persist={updateData} 
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default LcBasic
